<template>
  <div class="page-col">
    <div class="page-main">
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #0f766e 0%, #155e75 100%);">
            <i class="fa fa-check-square-o text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Conferência Financeira</h4>
            <small class="text-muted small">Listagem e acompanhamento das conferências financeiras</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end list-header-actions">
          <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
            <b-button-group class="mr-2 d-none d-lg-inline-flex">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel" v-b-tooltip.hover title="Exportar Excel">
                <i class="fa fa-file-excel-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml" v-b-tooltip.hover title="Imprimir Listagem">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <b-button-group class="mr-2 d-lg-none">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro" v-b-tooltip.hover title="Limpar">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-2 search-pill-field search-pill-field-data">
              <CecInputData v-model="filtroDataInicial" class="mx-1 search-pill-date" @keydown.enter.native="pesquisar" />
              <span class="text-muted mx-1 d-none d-sm-inline">até</span>
              <CecInputData v-model="filtroDataFinal" class="mx-1 search-pill-date" @keydown.enter.native="pesquisar" />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-2 search-pill-field search-pill-field-select">
              <b-form-select v-model="filtroTipoPeriodo" :options="tipoPeriodoOptions" class="border-0 bg-transparent py-0 search-pill-select" />
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar">
              <i class="fa fa-search mr-1"></i>
              <span class="d-none d-sm-inline">FILTRAR</span>
            </b-button>
          </div>

          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo">
            <i class="fa fa-plus-circle mr-1"></i>
            <span class="d-none d-sm-inline">Nova Conferência</span>
          </b-button>
        </div>
      </div>

      <b-collapse v-model="filtroAvancado">
        <div class="px-4 pb-4">
          <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
            <b-row align-v="end">
              <b-col md="5">
                <label class="small font-weight-bold text-muted">Conta</label>
                <ContaDropDown v-model="filtroContaId" />
              </b-col>
              <b-col md="3">
                <label class="small font-weight-bold text-muted">Status</label>
                <b-form-select v-model="filtroStatus" :options="statusOptions" class="shadow-xs rounded-pill" />
              </b-col>
            </b-row>
          </div>
        </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              ref="tbl"
              class="mb-0 table-finance"
              :head-variant="isDark ? 'dark' : 'light'"
              :dark="isDark"
              show-empty
              empty-text="Nenhuma conferência encontrada"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="clicarLinha"
              @row-dblclicked="editar"
              :tbody-tr-class="rowClassSelecionado">

              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(CONTA_NOME)>
                <SetFilter label="Conta" v-model="filtros.CONTA_NOME" :options="opcoes.CONTA_NOME" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(STATUS)>
                <SetFilter label="Status" v-model="filtros.STATUS" :options="opcoes.STATUS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DATA_CADASTRO)>
                <SetFilter label="Data Cadastro" v-model="filtros.DATA_CADASTRO" :options="opcoes.DATA_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(USUARIO_CADASTRO)>
                <SetFilter label="Usuário Cadastro" v-model="filtros.USUARIO_CADASTRO" :options="opcoes.USUARIO_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(USUARIO_CONFIRMOU)>
                <SetFilter label="Usuário Confirmou" v-model="filtros.USUARIO_CONFIRMOU" :options="opcoes.USUARIO_CONFIRMOU" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>

              <template #cell(DATA_INICIO)="row">
                {{ formatarDataBR(row.item.DATA_INICIO) }}
              </template>

              <template #cell(DATA_FIM)="row">
                {{ formatarDataBR(row.item.DATA_FIM) }}
              </template>

              <template #cell(DATA_CADASTRO)="row">
                {{ formatarDataBR(row.item.DATA_CADASTRO) }}
              </template>

              <template #cell(STATUS)="row">
                <b-badge :variant="getVariantStatus(row.item.STATUS)" pill>
                  {{ getLabelStatus(row.item.STATUS) }}
                </b-badge>
              </template>

              <template #cell(TOTAL_CREDITO_SISTEMA)="row">
                <span class="text-right d-block font-weight-bold text-success">{{ formatarMoeda(row.item.TOTAL_CREDITO_SISTEMA) }}</span>
              </template>

              <template #cell(TOTAL_DEBITO_SISTEMA)="row">
                <span class="text-right d-block font-weight-bold text-danger">{{ formatarMoeda(row.item.TOTAL_DEBITO_SISTEMA) }}</span>
              </template>

              <template #cell(DIFERENCA_TOTAL)="row">
                <span class="text-right d-block font-weight-bold" :class="Math.abs(Number(row.item.DIFERENCA_TOTAL || 0)) < 0.009 ? 'text-success' : 'text-warning'">
                  {{ formatarMoeda(row.item.DIFERENCA_TOTAL) }}
                </span>
              </template>

              <template #cell(actions)="row">
                <div class="d-flex justify-content-center">
                  <b-button type="button" @click.stop.prevent="imprimirItem(row.item)" variant="soft-info" pill class="btn-icon-only shadow-sm mr-1" title="Imprimir registro" v-b-tooltip.hover>
                    <i class="fa fa-print"></i>
                  </b-button>
                  <b-button
                    v-if="String(row.item.STATUS || '') === statusConferencia.ABERTA"
                    type="button"
                    @click.stop.prevent="abrirModalCancelar(row.item)"
                    variant="soft-danger"
                    pill
                    class="btn-icon-only shadow-sm"
                    title="Cancelar conferência aberta"
                    v-b-tooltip.hover>
                    <i class="fa fa-ban"></i>
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalCancelar"
      id="modal-cancelar-conferencia-financeira"
      hide-header
      hide-footer
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
      centered
      size="lg"
      @shown="focarCampoMotivoCancelamento">

      <div class="modal-header-premium p-3 d-flex align-items-center bg-danger" style="background: linear-gradient(135deg, #dc3545 0%, #a71d2a 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-ban text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Cancelar Conferência</h5>
          <small class="text-white opacity-75">O cancelamento exige justificativa e mantém o histórico</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalCancelar.hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4 bg-white" v-if="itemCancelar">
        <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
          <b-row align-v="center">
            <b-col md="5">
              <small class="modal-label-premium">Conta</small>
              <h5 class="mb-0 font-weight-bold text-dark">{{ itemCancelar.CONTA_CODIGONOME || itemCancelar.CONTA_NOME || itemCancelar.CONTA_ID }}</h5>
            </b-col>
            <b-col md="4" class="border-left">
              <small class="modal-label-premium">Período</small>
              <h6 class="mb-0 font-weight-bold text-primary">{{ formatarDataBR(itemCancelar.DATA_INICIO) }} até {{ formatarDataBR(itemCancelar.DATA_FIM) }}</h6>
            </b-col>
            <b-col md="3" class="border-left text-right">
              <small class="modal-label-premium">Diferença Total</small>
              <h5 class="mb-0 font-weight-bold text-danger">{{ formatarMoeda(itemCancelar.DIFERENCA_TOTAL) }}</h5>
            </b-col>
          </b-row>
        </div>

        <div class="modal-section-title mb-3">
          <i class="fa fa-pencil mr-2 text-danger"></i> Motivo do cancelamento
        </div>

        <b-form-textarea
          ref="motivoCancelamento"
          v-model="motivoCancelamento"
          rows="4"
          maxlength="500"
          placeholder="Descreva o motivo do cancelamento desta conferência"
          class="shadow-xs rounded">
        </b-form-textarea>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
        <b-button variant="soft-primary" pill class="px-4 font-weight-bold" @click="$refs.modalCancelar.hide()">
          FECHAR
        </b-button>
        <b-button variant="danger" pill class="px-5 font-weight-bold shadow-sm" :disabled="cancelando" @click="cancelar">
          <i class="fa fa-ban mr-1"></i> CONFIRMAR CANCELAMENTO
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import ContaDropDown from '@/views/componentes/dropdown/ContaDropDown.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx } from '@/utils/RelatorioHTML'
import {
  STATUS_CONFERENCIA_FINANCEIRA,
  getLabelStatusConferenciaFinanceira,
  getVariantStatusConferenciaFinanceira,
  getOptionsStatusConferenciaFinanceira
} from '@/utils/conferenciaFinanceiraStatus'

export default {
  components: {
    SetFilter,
    CecInputData,
    ContaDropDown
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'CONTA_NOME', type: 'string', label: 'Conta' },
      {
        key: 'STATUS',
        type: 'string',
        label: 'Status',
        labelMap: {
          [STATUS_CONFERENCIA_FINANCEIRA.ABERTA]: 'Em Andamento',
          [STATUS_CONFERENCIA_FINANCEIRA.FECHADA]: 'Fechada',
          [STATUS_CONFERENCIA_FINANCEIRA.CANCELADA]: 'Cancelada'
        }
      },
      { key: 'DATA_CADASTRO', type: 'date', label: 'Data Cadastro' },
      { key: 'USUARIO_CADASTRO', type: 'string', label: 'Usuário Cadastro' },
      { key: 'USUARIO_CONFIRMOU', type: 'string', label: 'Usuário Confirmou' }
    ]
  }, { useExternalPaging: false })],

  data() {
    return {
      isBusy: false,
      cancelando: false,
      filtroAvancado: false,
      itemCancelar: null,
      motivoCancelamento: '',
      statusConferencia: STATUS_CONFERENCIA_FINANCEIRA,
      statusOptions: getOptionsStatusConferenciaFinanceira(),
      tipoPeriodoOptions: [
        { value: 'MOVIMENTO', text: 'Período Movimento' },
        { value: 'CADASTRO', text: 'Período Cadastro' }
      ],
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'CONTA_NOME', label: 'Conta', sortable: true, thStyle: { width: '220px' } },
        { key: 'DATA_INICIO', label: 'Período De', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'DATA_FIM', label: 'Período Até', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'DATA_CADASTRO', label: 'Data Cadastro', sortable: true, class: 'text-center', thStyle: { width: '130px' } },
        { key: 'TOTAL_CREDITO_SISTEMA', label: 'Crédito Sistema', sortable: true, class: 'text-right', thStyle: { width: '150px' } },
        { key: 'TOTAL_DEBITO_SISTEMA', label: 'Débito Sistema', sortable: true, class: 'text-right', thStyle: { width: '150px' } },
        { key: 'DIFERENCA_TOTAL', label: 'Diferença', sortable: true, class: 'text-right', thStyle: { width: '140px' } },
        { key: 'STATUS', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: '130px' } },
        { key: 'USUARIO_CADASTRO', label: 'Usuário Cadastro', sortable: true, thStyle: { width: '160px' } },
        { key: 'USUARIO_CONFIRMOU', label: 'Usuário Confirmou', sortable: true, thStyle: { width: '160px' } },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '110px' } }
      ]
    }
  },

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('conferenciaFinanceira', [
      'LISTA',
      'FILTRO_CONTA_ID',
      'FILTRO_DATA_INICIAL',
      'FILTRO_DATA_FINAL',
      'FILTRO_TIPO_PERIODO',
      'FILTRO_STATUS',
      'REGISTRO_SELECIONADO_ID',
      'RECARREGAR_LISTA'
    ]),
    lista: {
      get() { return this.LISTA || [] },
      set(value) { this.$store.commit('conferenciaFinanceira/SET_LISTA', value) }
    },
    filtroContaId: {
      get() { return this.FILTRO_CONTA_ID },
      set(value) { this.$store.commit('conferenciaFinanceira/SET_FILTRO_CONTA_ID', value) }
    },
    filtroDataInicial: {
      get() { return this.FILTRO_DATA_INICIAL },
      set(value) { this.$store.commit('conferenciaFinanceira/SET_FILTRO_DATA_INICIAL', value) }
    },
    filtroDataFinal: {
      get() { return this.FILTRO_DATA_FINAL },
      set(value) { this.$store.commit('conferenciaFinanceira/SET_FILTRO_DATA_FINAL', value) }
    },
    filtroTipoPeriodo: {
      get() { return this.FILTRO_TIPO_PERIODO },
      set(value) { this.$store.commit('conferenciaFinanceira/SET_FILTRO_TIPO_PERIODO', value) }
    },
    filtroStatus: {
      get() { return this.FILTRO_STATUS },
      set(value) { this.$store.commit('conferenciaFinanceira/SET_FILTRO_STATUS', value) }
    }
  },

  methods: {
    clicarLinha(item) {
      this.$store.commit('conferenciaFinanceira/SET_REGISTRO_SELECIONADO_ID', item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      return item.ID === this.REGISTRO_SELECIONADO_ID ? 'cec-row-selected' : ''
    },
    async pesquisar() {
      this.isBusy = true
      try {
        await this.$store.dispatch('conferenciaFinanceira/GET_LISTA')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
      } finally {
        this.isBusy = false
      }
    },
    inicializarDatasFiltro() {
      const hoje = Tools.getDataAtual()
      if (!this.filtroDataInicial) this.filtroDataInicial = hoje
      if (!this.filtroDataFinal) this.filtroDataFinal = hoje
    },
    limparFiltro() {
      this.$store.commit('conferenciaFinanceira/SET_LIMPAR')
      this.inicializarDatasFiltro()
      this.pesquisar()
    },
    novo() {
      this.$router.push('/movimentos/conferencia-financeira/add')
    },
    editar(item) {
      this.$router.push(`/movimentos/conferencia-financeira/edit/${item.ID}`)
    },
    imprimirItem(item) {
      printHtmlReport({
        rows: [item],
        columns: this.colunas.filter(coluna => coluna.key !== 'actions'),
        reportTitle: `Conferência Financeira ${item.ID}`,
        printedBy: window.localStorage.getItem('login') || 'sistema',
        landscape: true
      })
    },
    abrirModalCancelar(item) {
      this.itemCancelar = item
      this.motivoCancelamento = ''
      this.$refs.modalCancelar.show()
    },
    async cancelar() {
      if (!this.itemCancelar) return
      if (!String(this.motivoCancelamento || '').trim()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o motivo do cancelamento.')
        return
      }

      this.cancelando = true
      try {
        await this.$http.post(`/api/protected/conferenciaFinanceira/${this.itemCancelar.ID}/cancelar`, {
          login: window.localStorage.getItem('login') || 'sistema',
          motivo: this.motivoCancelamento
        })
        this.$refs.modalCancelar.hide()
        this.$store.commit('conferenciaFinanceira/SET_RECARREGAR_LISTA', true)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Conferência financeira cancelada com sucesso.')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
      } finally {
        this.cancelando = false
      }
    },
    focarCampoMotivoCancelamento() {
      this.$nextTick(() => {
        if (this.$refs.motivoCancelamento && typeof this.$refs.motivoCancelamento.focus === 'function') {
          this.$refs.motivoCancelamento.focus()
        }
      })
    },
    getLabelStatus(status) {
      return getLabelStatusConferenciaFinanceira(status)
    },
    getVariantStatus(status) {
      return getVariantStatusConferenciaFinanceira(status)
    },
    formatarDataBR(data) {
      return Tools.formatarDataBR(data)
    },
    formatarMoeda(valor) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor || 0))
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(coluna => coluna.key !== 'actions'),
        filename: 'ConferenciaFinanceira.xlsx',
        sheetName: 'ConferenciaFinanceira'
      })
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.colunas.filter(coluna => coluna.key !== 'actions'),
        reportTitle: 'Conferência Financeira',
        printedBy: window.localStorage.getItem('login') || 'sistema',
        landscape: true
      })
    }
  },

  async created() {
    this.inicializarDatasFiltro()
    await this.pesquisar()
  },

  watch: {
    RECARREGAR_LISTA(value) {
      if (!value) return
      this.pesquisar()
      this.$store.commit('conferenciaFinanceira/SET_RECARREGAR_LISTA', false)
    }
  }
}
</script>

<style scoped>
.table-finance {
  font-size: 0.82rem;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.search-pill-responsive {
  min-height: 52px;
}

.search-pill-field {
  min-height: 38px;
}

.search-pill-field-data {
  white-space: nowrap;
}

.search-pill-date {
  width: 138px;
}

.search-pill-field-select {
  min-width: 185px;
}

.search-pill-select {
  width: 170px;
}

.list-header-actions {
  row-gap: 0.5rem;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}

.modal-header-premium {
  border-bottom: none;
}

.modal-info-bar {
  border-radius: 14px;
}

.modal-footer-premium {
  border-top: 1px solid #e9ecef;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.page-col .table.table-sm thead th {
  padding: 0.28rem 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  vertical-align: middle;
}

.page-col .table.table-sm tbody td {
  padding: 0.24rem 0.45rem;
  font-size: 0.79rem;
  line-height: 1.2;
  vertical-align: middle;
}

.page-col .table.table-sm tbody td .badge {
  font-size: 0.68rem;
  padding: 0.28rem 0.45rem;
}

@media (max-width: 991.98px) {
  .search-pill-responsive {
    width: 100%;
    border-radius: 1rem !important;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .search-pill-field,
  .search-pill-field-data {
    width: 100%;
    min-width: 100%;
  }

  .search-pill-field-select,
  .search-pill-select {
    width: 100%;
    min-width: 100%;
  }

  .search-pill-field {
    border-left: 0 !important;
    padding-left: 0.35rem !important;
    padding-right: 0.35rem !important;
  }

  .search-pill-field-data {
    justify-content: space-between;
  }

  .search-pill-date {
    width: calc(50% - 1.1rem);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/financeiro/conferencia-financeira/ConferenciaFinanceiraListagem.vue